import siteInsight from "../extract";
import config from "../config";
import styles from "./style.css";

styles && document && (document.head.appendChild(document.createElement("style")).innerHTML = styles);

const containerClass = "af-ad-d2s";

const renderKeywords = (parent, keywords) => {
  const header = document.createElement("header");
  header.innerHTML = `<span>${config.adTerm}</span><span>Sponsored</span>`;
  parent.appendChild(header);

  keywords.forEach(({ url, keyword }, i) => {
    const li = document.createElement("li");

    li.innerHTML = `<a class="keyword" href="${url}" onclick="fetch('${config.postbackUrl}')" target="_blank">${
      config.style == "3" ? `${i + 1}&nbsp;&nbsp;` : ""
    }${keyword}</a>`;
    parent.appendChild(li);
  });
};

export default () =>
  setInterval(() => {
    const container = config.node.parentNode;
    const containerEmpty = !container.querySelector(`.${containerClass}`);

    if (containerEmpty) {
      const content = document.createElement("ul");
      content.className = containerClass;

      container.insertBefore(content, config.node);

      const corpus = [ window.parent != window ? window.parent.document.body : document.body ];

      siteInsight(corpus, config.categoryFallback)
        .then(([categories, keywords, isSensitive, detailed]) => {
          console.log("%cKeyword Results:", "color: #555; font-size: 20px");
          console.table(keywords);

          console.log("%cFinal Result:", "color: #555; font-size: 20px");
          console.log(
            isSensitive
              ? "Unsafe content detected. No keywords rendered."
              : `Content is safe. Rendered ${keywords.length} keyword(s).`
          );

          if (!isSensitive && keywords.length) {
            content.classList.add("style" + config.style);
            renderKeywords(content, keywords);
          }
        })
        .catch((err) => console.log(err));
    }
  }, 500);
